// src/utils/firebaseRedirect.js - When to send visitors from Firebase Hosting URLs to the production domain

/**
 * True when production is being served from a Firebase Hosting URL
 * (*.web.app or *.firebaseapp.com) and should redirect to oracy.solutions.
 * @param {string} environment - REACT_APP_ENVIRONMENT
 * @param {string} hostname - window.location.hostname
 * @returns {boolean}
 */
export const shouldRedirectToProductionDomain = (environment, hostname) =>
  environment === 'production' &&
  (hostname.endsWith('.web.app') || hostname.endsWith('.firebaseapp.com'));
